import { CloseButton } from "custom_modules/EvidenceGallaryModal/EvidenceGalleryModal";
import { PrimaryBgButton } from "styledComponents/buttons";
import { CommonGrid, CommonImage, CommonText, InputField, InputWithLabelSection } from "styledComponents/common";



import deleteIcon from "../../../assets/img/icons/delete-3.svg";
import Pencil from "../../../assets/img/icons/pencil_26.svg";
import UploadNew from "../../../assets/img/icons/upload_26.svg";
import { DeleteButtonStyled, DeleteWrapper, FileName, FileUploadBox, FileUploadContainer, IconTextOpenButton, PreviewImage, UploadBox } from "../invoiceStyles";


const InvoiceOrganizationInformation = ({
  organizationNameRef,
  invoiceConfig,
  handleInputChange,
  addressRef,
  emailRef,
  phoneRef,
  logoPreview,
  signPreview,
  organizationLogo,
  digitalSign,
  logoFileRef,
  digitalSignFileRef,
  setOrganizationLogo,
  setLogoPreview,
  setIsLogoFromServer,
  setIsLogoModified,
  setDigitalSign,
  setSignPreview,
  setIsSignFromServer,
  setIsSignModified,
  removeFile,
  handleFileChange,
  isSaving,
  handleSaveOrganization,
  isSignatureModalOpen,
  isSignatureSubmitted,
  handleOpenSignatureModal,
  handleDeleteSignature,
  handleEditSignature,
  hasChanges,
}) => {
  return (
    <CommonGrid
      columns="1fr"
      bgColor="#E9F0FE"
      padding="24px"
      margin="0"
      gap="20px"
      alignContent="start"
      style={{ borderRadius: "8px" }}
    >
      <CommonText fontWeight="bold" name fontSize="20px">
        Organization Information
      </CommonText>
      <CommonGrid columns="1fr" gap="30px">
        <InputWithLabelSection>
          <CommonText>Organization Name</CommonText>
          <InputField
            ref={organizationNameRef}
            placeholder="Type Organization Name..."
            defaultValue={invoiceConfig?.name || ""}
            onChange={handleInputChange}
          />
        </InputWithLabelSection>
        <InputWithLabelSection>
          <CommonText>Organization Address</CommonText>
          <InputField
            ref={addressRef}
            placeholder="Type Organization Address..."
            defaultValue={invoiceConfig?.address || ""}
            onChange={handleInputChange}
          />
        </InputWithLabelSection>
        <InputWithLabelSection>
          <CommonText>Email Address</CommonText>
          <InputField
            ref={emailRef}
            placeholder="Type Organization Email Address..."
            defaultValue={invoiceConfig?.email || ""}
            onChange={handleInputChange}
          />
        </InputWithLabelSection>
        <InputWithLabelSection>
          <CommonText>Phone No</CommonText>
          <InputField
            ref={phoneRef}
            placeholder="Type Organization Phone Number..."
            defaultValue={invoiceConfig?.phone || ""}
            onChange={handleInputChange}
          />
        </InputWithLabelSection>
        <CommonGrid columns="1fr 1fr" gap="30px">
          {/* Logo Upload Section */}
          <InputWithLabelSection style={{ alignContent: "baseline" }}>
            <CommonText>Organization Logo</CommonText>
            <FileUploadContainer>
              {logoPreview ? (
                <div>
                  <FileUploadBox>
                    <CloseButton
                      size="24px"
                      top="0px"
                      right="0px"
                      onClick={() =>
                        removeFile(
                          setOrganizationLogo,
                          setLogoPreview,
                          logoPreview,
                          setIsLogoFromServer,
                          setIsLogoModified,
                        )
                      }
                      aria-label="Close"
                    >
                      ×
                    </CloseButton>
                    <PreviewImage
                      src={logoPreview}
                      alt="Organization Logo Preview"
                    />
                  </FileUploadBox>
                  {organizationLogo && (
                    <FileName title={organizationLogo.name}>
                      {organizationLogo.name}
                    </FileName>
                  )}
                </div>
              ) : (
                <UploadBox
                  onClick={() => logoFileRef.current?.click()}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      logoFileRef.current?.click();
                    }
                  }}
                >
                  <CommonImage src={UploadNew} alt="add" width="24px" />
                  <CommonText
                    fontSize="12px"
                    color="#6776cb"
                    margin="8px 0 0 0"
                  >
                    Add Logo
                  </CommonText>
                </UploadBox>
              )}
              <input
                ref={logoFileRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange(
                  logoFileRef,
                  setOrganizationLogo,
                  setLogoPreview,
                  setIsLogoFromServer,
                  setIsLogoModified,
                )}
                style={{ display: "none" }}
              />
            </FileUploadContainer>
          </InputWithLabelSection>

          {/* Digital Signature Section - Preview Only */}
          {isSignatureSubmitted && signPreview && (
            <InputWithLabelSection style={{ alignContent: "baseline" }}>
              <CommonText>Digital Signature</CommonText>
              <FileUploadContainer>
                <div>
                  <FileUploadBox>
                    <CloseButton
                      size="24px"
                      top="0px"
                      right="0px"
                      onClick={handleDeleteSignature}
                      aria-label="Delete"
                    >
                      ×
                    </CloseButton>
                    <PreviewImage
                      src={signPreview}
                      alt="Digital Signature Preview"
                    />
                  </FileUploadBox>
                  <FileName
                    title={digitalSign?.name || "digital_signature.png"}
                  >
                    {digitalSign?.name || "digital_signature.png"}
                  </FileName>
                </div>
              </FileUploadContainer>
            </InputWithLabelSection>
          )}
        </CommonGrid>

        <IconTextOpenButton onClick={handleOpenSignatureModal}>
          <CommonImage src={Pencil} alt="add" width="20px" />
          <CommonText fontSize="14px" margin="0 0 0 4px">
            {isSignatureSubmitted && signPreview
              ? "Update Digital Signature"
              : "Add Digital Signature"}
          </CommonText>
        </IconTextOpenButton>

         {hasChanges && (<PrimaryBgButton
          marginTop="0px"
          onClick={handleSaveOrganization}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save Changes"}
        </PrimaryBgButton>)}
      </CommonGrid>
    </CommonGrid>
  );
};

export default InvoiceOrganizationInformation;